import { Navigate, useLocation } from 'react-router-dom';
import { api } from '../api/api';

export default function AuthGuard({ children }) {
  const location = useLocation();
  if (!api.checkAuth()) {
    // 戻り先を持たせる。トークンの期限切れは api.js の _getToken() が
    // リクエスト前に検出するので、期限切れの導線は401ハンドラではなく
    // ここを通る。next を落とすとブックマークや共有リンクから来たときに
    // 必ずダッシュボードへ飛ばされてしまう。
    const back = location.pathname + location.search;
    return <Navigate to={`/?next=${encodeURIComponent(back)}`} replace />;
  }
  return children;
}
